<script lang="ts">
	import { Picture } from "@ishavskraft/shared";
	import { RING_MEG_FORM_ID } from "#lib/ringMeg.js";
	import RingMegModal from "#lib/RingMegModal.svelte";
	import type { AvtaleCustomerSupport } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";

	type Props = {
		customerSupport: AvtaleCustomerSupport;
	};
	let { customerSupport }: Props = $props();

	let dialogOpen = $state(false);
</script>

<div
	class="mx-edge-x mb-8 py-6 px-4 rounded-xl tablet:mb-11 bg-[--aurora-30] flex flex-col laptop:flex-row gap-6"
>
	<div class="tablet:basis-1/2 flex flex-col">
		<h2>{customerSupport.title}</h2>
		{#if customerSupport.description?.length}
			<PortableText value={customerSupport.description.filter(Boolean)} />
		{/if}

		<div class="mb-6 mt-auto">
			<button
				type="button"
				class="button button-primary shrink-0"
				onclick={() => (dialogOpen = true)}
			>
				{customerSupport.buttonText}
			</button>
		</div>
	</div>
	<div class="tablet:basis-1/2">
		{#if customerSupport.image && customerSupport.image.src}
			<Picture
				src={customerSupport.image.src}
				srcset={customerSupport.image.srcset}
				srcsetWebp={customerSupport.image.srcsetWebp}
				alt={customerSupport.image.alt}
				class="rounded-xl"
			/>
		{/if}
	</div>
</div>

<RingMegModal bind:open={dialogOpen} formId={RING_MEG_FORM_ID} />
